<template>
  <div class="basic_wrap">
    <div
      id="red_top_bg"
      class="red_top_bg"
      style="z-index: 10000;background: rgba(0, 0, 0, 0.88) !important;color:fff"
    >
      <div
        class="logo"
        style="display: flex;
		        align-items: center;
		        gap: 10px;
		        font-size: 16px;
		        font-weight: 800;
		        color: #fff;
		        letter-spacing: -0.4px;"
      >
        <div
          class="logo-dot"
          style="width: 32px;
		        height: 32px;
		        border-radius: 9px;
		        overflow: hidden;
		        flex-shrink: 0;
		        display: flex;
		        align-items: center;
		        justify-content: center;"
        >
          <img
            :src="logo"
            alt="logo"
            class="logo-dot-img"
            style="width: 100%;
		        height: 100%;
		        object-fit: cover;
		        display: block;"
          > 
        </div>
        {{ app.name }}
      </div>
      <div
        class="language"
        style="display: flex;
		align-items: center;
		justify-content: center;
		background: transparent;
		border: none;
		padding: 6px;
		cursor: pointer;
		transition: opacity 0.2s;"
      >
        <img
          :src="require('../img/user/kf.png')"
          style=" width: 32px;
		      height: 32px;
		      object-fit: cover;
		      border-radius: 5px;
		      display: block;margin-right: 6px"
          @click="jump(service.kefu)"
        >
        <img
          :src="language_logo"
          style=" width: 32px;
		        height: 32px;
		        object-fit: cover;
		        border-radius: 9px;
		        display: block;"
          @click="$router.push('/language')"
        >
      </div>
    </div>
		
		
    <div
      class="ranking-hero"
      style="margin-top: 80px;"
    >
      <h1>{{ $t('utils.phb') }}</h1>
      <p
        class="subtitle"
        style="margin-top: 10px;"
      >
        {{ $t('utils.shishi') }}-{{ $t('utils.meiri') }}
      </p>
    </div>
		
		        
    <div class="genre-scroll-wrap">
      <div class="genre-scroll">
        <span
          v-for="(tab,index) in tabs"
          :key="index"
          class="genre-tag"
          :title="tab.title"
          :class="{ active: tab.id === active }"
          @click="qiehuan(tab.id)"
        >{{ tab.title }}</span>
      </div>
    </div>
		        	
		
		      
    <div
      v-if="filteredRankingList.length >= 3"
      class="top-three-section"
    >
      <div class="top-three-grid">
        <div
          v-if="filteredRankingList[1]"
          class="top-card"
         @click="$router.push({ name: 'investOne', params: { code: filteredRankingList[1].id } })"
        >
          <span class="rank-badge silver">2</span>
          <img
            :src="filteredRankingList[1].img"
            alt=""
            class="top-thumb"
            loading="lazy"
          >
          <div class="top-name">
            {{ filteredRankingList[1].title }}
          </div>
          <div class="top-score">
            {{ filteredRankingList[1].rating }}
          </div>
          <div class="top-meta">
            {{ filteredRankingList[1].genre }}
          </div>
          <div class="top-meta">
          {{ $t('utils.ji') }}  {{ filteredRankingList[2].episodes }}
          </div>
        </div>
		                
        <div
          v-if="filteredRankingList[0]"
          class="top-card first"
          @click="$router.push({ name: 'investOne', params: { code: filteredRankingList[0].id } })"
        >
          <div class="crown">
            <img
              src="../img/1.png"
              alt=""
              style="width: 28px;height: 28px"
            >
          </div>
          <img
            :src="filteredRankingList[0].img"
            alt=""
            class="top-thumb"
            loading="lazy"
          >
          <div class="top-name">
            {{ filteredRankingList[0].title }}
          </div>
          <div class="top-score">
            {{ filteredRankingList[0].rating }}
          </div>
          <div class="top-meta">
            {{ filteredRankingList[0].genre }}
          </div>
          <div class="top-meta">
           {{ $t('utils.ji') }}  {{ filteredRankingList[2].episodes }}
          </div>
        </div>
		                
        <div
          v-if="filteredRankingList[2]"
          class="top-card"
          
		   @click="$router.push({ name: 'investOne', params: { code: filteredRankingList[2].id } })"
        >
          <span class="rank-badge bronze">3</span>
          <img
            :src="filteredRankingList[2].img"
            alt=""
            class="top-thumb"
            loading="lazy"
          >
          <div class="top-name">
            {{ filteredRankingList[2].title }}
          </div>
          <div class="top-score">
            {{ filteredRankingList[2].rating }}
          </div>
          <div class="top-meta">
            {{ filteredRankingList[2].genre }}
          </div>
          <div class="top-meta">
          {{ $t('utils.ji') }}  {{ filteredRankingList[2].episodes }}
          </div>
        </div>
      </div>
    </div>
		
		       
    <div
      class="rank-full-list"
      style="margin-bottom: 80px;"
    >
      <div
        v-for="(item, idx) in remainingList"
        :key="item.id"
        class="rank-row"
        @click="$router.push({ name: 'investOne', params: { code: item.id } })"
      >
        <span class="rk-num">{{ item.rank }}</span>
        <div
          class="rk-thumb"
          :class="item.bgClass"
        >
          <img
            :src="item.img"
            alt=""
            loading="lazy"
          >
        </div>
        <div class="rk-info">
          <div class="rk-title">
            {{ item.title }}
          </div>
          <div
            class="rk-sub"
            style="margin-top: 5px;"
          >
            <span>{{ item.genre }}</span>
          </div>
          <div
            class="rk-sub"
            style="margin-top: 5px;"
          >
            <span>{{ $t('utils.ji') }}  {{ item.episodes }}</span>
          </div>
        </div>
        <span class="rk-score">{{ item.rating }}</span>
      </div>
    </div>
  </div>
</template>

<script>
	import Vue from 'vue';
	import bsHeader from '../../components/bsHeader.vue'
	import Fetch from '../../utils/fetch'
	import {
		Tab,
		Tabs,
		List,
		Empty,
		Lazyload
	} from 'vant';
	Vue.use(Tab).use(Tabs).use(List).use(Empty).use(Lazyload);
	export default {
		name: "Invest",
		components: {
			bsHeader
		},
		data() {
			return {
				data: [],
				show_tabs:false,
				tabs: [{
						id: 90,
						title: this.$t('tabs.all')
					}

				],
				service:'',
				active: 0,
				empty: false,
				loading: false,
				finished: false,
				list: [],
				page: 1,
				listRows: 8,
				language_logo: localStorage.getItem('language_logo'),
				logo: localStorage.getItem("logo2"),
				tabs: [{
						id: 0,
						title: this.$t('tabs.all')
					}
				
				],
				app: {
					"show": false,
					"name": "",
					"url": "",
					"logo": "",
				},
				total: [
					
				]
			};
		}, computed: {
                filteredRankingList() {
				  const list =this.total;
				  return list.map((item, idx) => ({
					  ...item,
					  rank: String(idx + 1).padStart(2, '0')
				  }));
			  },
			  remainingList() {
				  
				  return this.filteredRankingList.slice(3);
			  }
            },
		created() {
			if (window.plus) {
				plus.navigator.setStatusBarBackground('#FAFAFA');
				plus.navigator.setStatusBarStyle('dark');
			}
			this.$parent.footer('invest', true);
		},
		mounted() {
			if (this.$router.history.current.query.type) {
				this.active = parseInt(this.$router.history.current.query.type);
			}
			
			this.start();
		},
		methods: {
			change(item) {
				// if (item.type == 1) {
				// 	return this.common.precision_basic(item.min * item.rate * item.day / 100);
				// } else {
				// 	return this.common.precision_basic(item.min * item.rate / 100);
				// }
				return this.common.precision_basic(item.min * item.rate / 100);
			},changes(item) {
				return this.common.precision_basic(item.min * item.rate * item.day / 100);
			},
			start() {
				Fetch('/index/item_class').then((r) => {
					var tabs1 = [];
					r.data.classes.forEach(item => {
						tabs1.push({
							id: item.id,
							title: item.title,
						})
					})
					this.tabs = tabs1;
					this.show_tabs = true;
				});
				Fetch('/index/item_bangdan', {
					page: this.page,
					listRows: this.listRows,
					type: this.active
				}).then(r => {
					
					this.total=r.data.list.list;
					//console(this.newDramas);
				});
				Fetch('/index/int').then((r) => {
					block: {
						if (r.data.popup.show == 1) {
							var popup_show = sessionStorage.getItem("popup_show");
							sessionStorage.setItem("popup_show", r.data.popup.num);
							if (popup_show != null && popup_show == 1) {
								break block;
							}
							this.tc_content = r.data.popup.content;
							this.show_tc = true;
						}
					}
					this.loading = true;
					this.app = r.data.version;
					this.new_list = r.data.new_list;
					this.service = r.data.service;
					this.showApp();
				});
			},qiehuan(id){
				this.active = id;
				Fetch('/index/item_bangdan', {
					page: this.page,
					listRows: this.listRows,
					type: this.active
				}).then(r => {
					
					this.total=r.data.list.list;
					//console(this.newDramas);
				});
			},
			sort(index) {
				this.page = 1;
				this.empty = false;
				this.list = [];
				this.finished = false;
				this.loading = true;
				this.onLoad();
			},
			onLoad() {
				Fetch('/index/item_list', {
					page: this.page,
					listRows: this.listRows,
					type: this.tabs[this.active]['id']
				}).then(r => {
					if (r.data.length == 0) this.empty = true;
					var list = r.data.list;
					for (var i = 0; i < list.length; i++) {
						this.list.push(list[i]);
					}
					if (this.list.length >= r.data.length) {
						this.finished = true;
						return;
					}
					this.page = this.page + 1;
					this.loading = false;
				});
			}
		}
	};
</script>

<style lang="less" scoped>
	.home_wrap {
		margin-bottom: 60px;
		/* 给页面主体默认顶部内边距，避免固定头部遮挡内�*/
		padding-top: 68px;
		height: 100%;
		min-height: 100vh;
		background-color: var(--bg-primary);
		color: var(--text-primary);
	
	
	}
	
	.red_top_bg {
		position: fixed !important;
		top: 0;
		left: 0;
		right: 0;
		z-index: 100000 !important;
		height: 68px;
		padding: 10px 0;
		background: hsla(0, 0%, 100%, .96);
		border-bottom: 1px solid #edf0f6;
		box-shadow: 0 2px 14px rgba(35, 65, 112, .06);
		/* 确保不会�transform/stacking context 覆盖 */
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		.logo {
			position: absolute;
			top: 10px;
			left: 3%;
			height: 48px;
		
			img {
				height: 100%;
			}
		}
		.language {
			position: absolute;
			top: 19px;
			right: 2%;
			height: 36px;
		
			img {
				height: 100%;
			}
		}
	}
	.ranking-hero {
	            padding: 20px 20px 8px;
	        }
	        .ranking-hero h1 {
	            font-size: 28px;
	            font-weight: 900;
	            letter-spacing: -0.6px;
	            margin-bottom: 4px;
	            color: #fff;
	        }
	        .ranking-hero .subtitle {
	            font-size: 13px;
	            color: var(--text-muted);
	            font-weight: 500;
	            letter-spacing: 0.01em;
	        }
	
	        /* ========== 榜单分类Tab ========== */
	        .ranking-tabs-wrap {
	            padding: 0 16px;
	            margin-bottom: 6px;
	        }
	        .ranking-tabs {
	            display: flex;
	            gap: 8px;
	            overflow-x: auto;
	            scroll-behavior: smooth;
	            -webkit-overflow-scrolling: touch;
	            touch-action: pan-x;
	            -ms-overflow-style: none;
	            scrollbar-width: none;
	            padding: 6px 2px 10px;
	        }
	        .ranking-tabs::-webkit-scrollbar {
	            display: none;
	        }
	        .ranking-tab {
	            flex-shrink: 0;
	            padding: 10px 22px;
	            border-radius: 22px;
	            font-size: 13px;
	            font-weight: 600;
	            cursor: pointer;
	            background: var(--bg-card);
	            color: var(--text-secondary);
	            border: 1px solid var(--border);
	            transition: all 0.25s ease;
	            white-space: nowrap;
	            letter-spacing: 0.01em;
	        }
	        .ranking-tab.active {
	            background: #fff;
	            color: #000;
	            border-color: #fff;
	            font-weight: 700;
	            box-shadow: 0 4px 20px rgba(255, 255, 255, 0.2);
	        }
	        .ranking-tab:active {
	            transform: scale(0.95);
	        }
	
	        /* ========== 前三名展示区 ========== */
	        .top-three-section {
	            padding: 8px 16px 4px;
	            overflow: hidden;
	        }
	        .top-three-grid {
	            display: grid;
	            grid-template-columns: 1fr 1.2fr 1fr;
	            gap: 10px;
	            align-items: end;
	        }
	        .top-card {
	            background: var(--bg-card);
	            border-radius: var(--radius-lg);
	            padding: 16px 10px 14px;
	            text-align: center;
	            cursor: pointer;
	            border: 1px solid var(--border);
	            transition: all 0.25s ease;
	            position: relative;
	            box-shadow: var(--shadow-card);
	            overflow: hidden;
	            min-width: 0;
	        }
	        .top-card:active {
	            transform: scale(0.96);
	            border-color: rgba(255, 255, 255, 0.18);
	        }
	        .top-card.first {
	            padding: 20px 10px 18px;
	            border-color: var(--accent-gold);
	            box-shadow: 0 0 24px rgba(251, 191, 36, 0.15);
	        }
	        .top-card .crown {
	            font-size: 28px;
	            margin-bottom: 4px;
	        }
	        .top-card .rank-badge {
	            display: inline-block;
	            width: 28px;
	            height: 28px;
	            border-radius: 50%;
	            font-size: 13px;
	            font-weight: 800;
	            line-height: 28px;
	            margin-bottom: 8px;
	            color: #000;
	        }
	        .rank-badge.gold {
	            background: var(--accent-gold);
	        }
	        .rank-badge.silver {
	            background: var(--accent-silver);
	        }
	        .rank-badge.bronze {
	            background: var(--accent-bronze);
	        }
	        .top-card .top-thumb {
	            width: 60px;
	            height: 60px;
	            border-radius: 50%;
	            object-fit: cover;
	            margin: 0 auto 10px;
	            display: block;
	            border: 2px solid rgba(255, 255, 255, 0.15);
	        }
	        .top-card.first .top-thumb {
	            width: 72px;
	            height: 72px;
	            border-color: var(--accent-gold);
	        }
	        .top-card .top-name,
	        .top-card .top-score,
	        .top-card .top-meta {
	            display: block;
	            width: 100%;
	            max-width: 100%;
	            overflow: hidden;
	            text-overflow: ellipsis;
	            white-space: nowrap;
	        }
	        .top-card .top-name {
	            font-size: 13px;
	            font-weight: 700;
	            margin-bottom: 3px;
	            color: #fff;
	        }
	        .top-card .top-score {
	            font-size: 14px;
	            font-weight: 700;
	            color: var(--accent-gold);
	        }
	        .top-card .top-meta {
	            font-size: 11px;
	            color: var(--text-muted);
	            margin-top: 2px;
	        }
	
	        /* ========== 完整排名列表 ========== */
	        .rank-full-list {
	            padding: 8px 16px;
	            display: flex;
	            flex-direction: column;
	            gap: 8px;
	        }
	        .rank-row {
	            display: flex;
	            align-items: center;
	            gap: 12px;
	            background: var(--bg-card);
	            border-radius: var(--radius-md);
	            padding: 13px 14px;
	            cursor: pointer;
	            border: 1px solid var(--border);
	            transition: all 0.2s ease;
	            box-shadow: var(--shadow-card);
	        }
	        .rank-row:active {
	            background: #1a1a24;
	            border-color: rgba(255, 255, 255, 0.15);
	            transform: scale(0.98);
	        }
	        .rank-row .rk-num {
	            font-size: 18px;
	            font-weight: 800;
	            color: var(--text-muted);
	            min-width: 30px;
	            text-align: center;
	            flex-shrink: 0;
	            font-variant-numeric: tabular-nums;
	        }
	        .rank-row .rk-thumb {
	            width: 46px;
	            height: 46px;
	            border-radius: var(--radius-sm);
	            flex-shrink: 0;
	            position: relative;
	            overflow: hidden;
	            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
	        }
	        .rank-row .rk-thumb img {
	            position: absolute;
	            top: 0;
	            left: 0;
	            width: 100%;
	            height: 100%;
	            object-fit: cover;
	        }
	        .rank-row .rk-info {
	            flex: 1;
	            min-width: 0;
	        }
	        .rank-row .rk-info .rk-title {
	            font-size: 14px;
	            font-weight: 600;
	            margin-bottom: 3px;
				color:#fff;
	            white-space: nowrap;
	            overflow: hidden;
	            text-overflow: ellipsis;
	        }
	        .rank-row .rk-info .rk-sub {
	            font-size: 11px;
	            color: var(--text-muted);
	            display: flex;
	            align-items: center;
	            gap: 6px;
	        }
	        .rank-row .rk-info .rk-sub .dot-sep {
	            width: 3px;
	            height: 3px;
	            background: var(--text-muted);
	            border-radius: 50%;
	        }
	        .rank-row .rk-score {
	            font-size: 15px;
	            font-weight: 700;
	            color: var(--accent-gold);
	            flex-shrink: 0;
	        }
	        .rank-row .rk-trend {
	            font-size: 13px;
	            margin-left: 2px;
	        }
	        .trend-up {
	            color: #22c55e;
	        }
	        .trend-down {
	            color: #ef4444;
	        }
	        .trend-same {
	            color: var(--text-muted);
	        }
	
	        /* ========== 底部导航 ========== */
	        .bottom-nav {
	            position: fixed;
	            bottom: 0;
	            left: 50%;
	            transform: translateX(-50%);
	            width: 100%;
	            max-width: 430px;
	            background: rgba(8, 8, 12, 0.96);
	            backdrop-filter: blur(28px);
	            -webkit-backdrop-filter: blur(28px);
	            border-top: 1px solid var(--border);
	            display: flex;
	            justify-content: space-around;
	            align-items: center;
	            padding: 10px 0 calc(10px + var(--safe-bottom));
	            z-index: 200;
	        }
	        .nav-tab {
	            display: flex;
	            flex-direction: column;
	            align-items: center;
	            gap: 5px;
	            cursor: pointer;
	            color: var(--text-muted);
	            transition: all 0.2s ease;
	            font-size: 10px;
	            font-weight: 500;
	            min-width: 52px;
	            padding: 6px 0;
	            letter-spacing: 0.02em;
	        }
	        .nav-tab .tab-icon {
	            font-size: 22px;
	            transition: transform 0.25s ease;
	        }
	        .nav-tab.active {
	            color: #fff;
	            font-weight: 700;
	        }
	        .nav-tab.active .tab-icon {
	            transform: translateY(-2px);
	        }
	        .nav-tab:active {
	            opacity: 0.6;
	        }
	/* ========== 分类标签 ========== */
	        .genre-scroll-wrap {
	            padding: 0 16px;
	            margin-bottom: 8px;
	            overflow: hidden;
	        }
	        .genre-scroll {
	            display: flex;
	            flex-wrap: nowrap;
	            gap: 10px;
	            overflow-x: auto;
	            overflow-y: hidden;
	            scroll-behavior: smooth;
	            -webkit-overflow-scrolling: touch;
	            touch-action: pan-x;
	            -ms-overflow-style: none;
	            scrollbar-width: none;
	            padding: 8px 2px 12px;
	            white-space: nowrap;
	            width: 100%;
	        }
	        .genre-scroll::-webkit-scrollbar {
	            display: none;
	        }
	        .genre-tag {
	            flex: 0 0 auto;
	            flex-shrink: 0;
	            padding: 10px 20px;
	            border-radius: 22px;
	            font-size: 13px;
	            font-weight: 600;
	            cursor: pointer;
	            background: var(--bg-card);
	            color: var(--text-secondary);
	            border: 1px solid var(--border);
	            transition: all 0.25s ease;
	            white-space: nowrap;
	            letter-spacing: 0.01em;
	        }
	        .genre-tag.active {
	            background: #fff;
	            color: #000;
	            border-color: #fff;
	            font-weight: 700;
	            box-shadow: 0 4px 20px rgba(255, 255, 255, 0.2);
	        }
	        .genre-tag:active {
	            transform: scale(0.95);
	        }
	        
			/* 背景占位 */
			        .bg-r1 { background: #c4101a; }
			        .bg-r2 { background: #d4456a; }
			        .bg-r3 { background: #e05500; }
			        .bg-r4 { background: #0d9488; }
			        .bg-r5 { background: #a31d3c; }
			        .bg-r6 { background: #4f46e5; }
			        .bg-r7 { background: #0891b2; }
			        .bg-r8 { background: #65a30d; }
			        .bg-r9 { background: #9333ea; }
			        .bg-r10 { background: #db2777; }
</style>
